import React from "react";
import {connect} from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
//import MenuItem from "@material-ui/core/MenuItem";
import Button from "components/CustomButtons/Button.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
//import countryList from 'country-list'
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";

import styles from "assets/jss/material-dashboard-pro-react/views/form";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

import {
  ibSave,
  //ibsFetch,
  ibFetch
} from 'actions/ibs'

import {
  plaformsFetch,
  plaformFilter
} from 'actions/platforms'

import {
  danger,
} from 'actions/notification'


/*const kyc = {
	PROOF_OF_ADDRESS: {key: 'PROOF_OF_ADDRESS', label:'Proof of Address'},
	PROOF_OF_ID: {key: 'PROOF_OF_ID', label: 'Proof of ID'}
}
const tradingAccountTypes = {
	VARIABLE: {key: 'VARIABLE', label:'Variable'},
	FIXED: {key: 'FIXED', label: 'Fixed'},
	RAW_COMMISSION: {key: 'RAW_COMMISSION', label: 'Raw_Commission'},
	SILVER: {key: 'SILVER', label: 'Silver'},
  	GOLD: {key: 'GOLD', label: 'Gold'}
}

const leverages = {
	LEVERAGE_500_1: {key: 'LEVERAGE_500_1', label:'500:1'},
	LEVERAGE_200_1: {key: 'LEVERAGE_200_1', label: '200:1'},
	LEVERAGE_100_1: {key: 'LEVERAGE_100_1', label: '100:1'}
}

const clientAccountCurrencies = {
	USD: {key: 'USD', label:'USD'},
	EUR: {key: 'EUR', label: 'EUR'},
	GBP: {key: 'GBP', label: 'GBP'}
}*/
const excludedCountries = {
	FINLAND: {key: 'FINLAND', label:'Finland'},
	RUSSIAN_FEDERATION: {key: 'RUSSIAN_FEDERATION', label: 'Russian Federation'},
	UNITED_KINGDOM: {key: 'UNITED_KINGDOM', label: 'United Kingdom'}
}


class IbKyc extends React.Component {
	state = {
		form: {
			salesOffice: '',
      salesRepresentative: '',
      accountPlatforms: [],
      ibKycs: [],
      accountTypes: [],
      accountLeverages: [],
      accountCurrencies: [],
      excludedCountry: '',
		},
  }

	componentDidMount() {
		this.props.plaformFilter({size: 100})
		this.props.platformsFetch()
		if(this.props.match.params.id) {
			delete this.props.stepDataObject.data.salesAgentId
			this.props.saveWizardData(this.props.stepDataObject.data)

			this.setState({
				...this.state,
				form: {
					salesOffice: this.props.stepDataObject.data.salesOffice,
					salesRepresentative: this.props.stepDataObject.data.salesRepresentative,
					accountPlatforms: this.props.stepDataObject.data.accountPlatforms,
					ibKycs: this.props.stepDataObject.data.ibKycs,
					accountTypes: this.props.stepDataObject.data.accountTypes,
					accountLeverages:this.props.stepDataObject.data.accountLeverages,
					accountCurrencies: this.props.stepDataObject.data.accountCurrencies,
					excludedCountry: this.props.stepDataObject.data.excludedCountry,
				}
			})
		}
	}

	change(event,name){
    this.setState({
      ...this.state,
      form:{
        ...this.state.form,
        [name]:event.target.value
      },
    })
	}
	getInput(data){
    return   <CustomInput
        labelText={
          <span>
            {data.name} {(data.required?<small>*</small>: "")}
          </span>
        }
        id={data.key}
        formControlProps={{
          fullWidth: true
        }}
        inputProps={{
          onChange: event => this.change(event, data.key),
          required:data.required,
          value:this.state.form[data.key] || '',
          type:data.type,
          endAdornment: (
            <InputAdornment
              position="end"
              className={this.props.classes.inputAdornment}
            >
              {data.icon}
            </InputAdornment>
          )
        }}
    />
	}
	submit(e){
    e.preventDefault()
    let data = {...this.props.wizardData, ...this.state.form}
		if(data.accountPlatforms === ''){
			delete data.accountPlatforms
		}
		if(data.ibKycs === ''){
			delete data.ibKycs
		}
		if(data.accountTypes === ''){
			delete data.accountTypes
		}
		if(data.accountLeverages === ''){
			delete data.accountLeverages
		}
		if(data.accountCurrencies === ''){
			delete data.accountCurrencies
		}
		if(data.excludedCountry === ''){
			delete data.excludedCountry
		}
    this.props.save(data)
      .then(e => {
				this.props.saveWizardData(e)
				this.props.history.push(`/administration/ibs`)
				//this.props.goToNextStep({data: e})
      })
      .catch(e=>{this.props.danger(e+'',4);})
	}
	setCheckboxValue(key, item){
		const {form} = this.state
		let keyItem = form[key]
		if(keyItem.includes(item)){ // remove it from list
			keyItem = keyItem.filter((x) => x !== item)
		} else { //add it in list
			keyItem.push(item)
		}
		this.setState({
			...this.state,
			form: {
				...form,
				[key]: keyItem
			}
		})
	}
	renderCheckbox(options){
		const {classes} = this.props
		const values = this.state.form[options.key]
		return(
			<div key={options.key} style={{paddingTop: '34px'}}>
				<InputLabel
					htmlFor={options.key}
					className={classes.selectLabel}
				>
					{options.label}
				</InputLabel>
				<div style={{borderTop: '1px solid #D2D2D2'}}>
          {options.options.map((item, i) => {
						return(
							<div
								key={item.key}
								className={
								classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}
							>
								<FormControlLabel
									control={
										<Checkbox
											tabIndex={-1}
											onClick={() => this.setCheckboxValue(options.key, item.key)}
											checked={values.includes(item.key)}
											checkedIcon={
												<Check className={classes.checkedIcon} />
											}
											icon={<Check className={classes.uncheckedIcon} />}
											classes={{
												checked: classes.checked
											}}
										/>
									}
									classes={{
										label: classes.label
									}}
									label={item.label}
								/>
							</div>
						)
					})}
				</div>
			</div>
		)
	}
  render() {
		const {classes} = this.props
		const countries = excludedCountries
  	return (
			<form onSubmit={(e) => this.submit(e)}>
				<GridContainer justify="center">
				
					<GridItem xs={12} sm={11} md={11}>

						{this.getInput({
							key:'salesOffice',
							name:'Sales Office',
							icon:'',
							type:'text',
							required:false
						})}

						{this.getInput({
							key:'salesRepresentative',
							name:'Sales Representative',
							icon:'',
							type:'text',
							required:false
						})}

					</GridItem>


					{/*<GridItem xs={12} sm={11} md={11}>
						{this.renderCheckbox({
							options: platforms.map((x) => {return{key:x.name, label:x.name}}),
							label: 'Platforms',
							key: 'accountPlatforms'
						})}

						{this.renderCheckbox({
							options: Object.values(kyc),
							label: 'KYC',
							key: 'ibKycs'
						})}

						{this.renderCheckbox({
							options: Object.values(tradingAccountTypes),
							label: 'Trading Account Types',
							key: 'accountTypes'
						})}

						{this.renderCheckbox({
							options: Object.values(leverages),
							label: 'Leverages',
							key: 'accountLeverages'
						})}

						{this.renderCheckbox({
							options: Object.values(clientAccountCurrencies),
							label: 'Client Account Currencies',
							key: 'accountCurrencies'
						})}
					</GridItem>*/}

					<GridItem xs={12} sm={11} md={11}>
						<FormControl
							fullWidth
							className={classes.selectFormControl}
							style={{marginTop:'10px', marginBottom: '17px'}}
						>

							<InputLabel
								htmlFor="excludedCountry"
								className={classes.selectLabel}
							>
								Excluded Country
							</InputLabel>

							<Select
								required={false}
								native
								value={this.state.form.excludedCountry || '' }
								MenuProps={{ className: classes.selectMenu }}
								classes={{ select: classes.select }}            
								inputProps={{
									onChange: event => this.change(event, "excludedCountry"),
									id: "excludedCountry"
								}}
							>
								<option value="" disabled></option>
								{Object.values(countries).map(item => 
									<option key={item.key} value={item.key}>{item.label}</option>
								)}
							</Select>  
						</FormControl>
					</GridItem>

					<GridItem sm={11}>
						<div style={{float: 'left'}}>
							<Button
								// color="success"
								type="button"
								onClick={(e) => this.props.goToPreviousStep()}
								style={{position:'absolute', bottom:'10px', left:'40px'}}
							>
								Previous
							</Button>
						</div>
						<div style={{float: 'right'}}>
							{/*<Button
								color="success"
								type="submit"
								style={{position:'absolute', bottom:'10px', right:'40px'}}
							>
								Next
							</Button>*/}
							<Button
							color="success"
							type="button"
							style={{position:'absolute', bottom:'10px', right:'40px'}}
							onClick={(e) => this.submit(e)}
						>
							DONE
						</Button>
						</div>
					</GridItem>
				</GridContainer>
			</form>
  	);
  }
}
const state=(state)=>({
	ibs: state.ibs,
	platforms: state.platforms.list
})
const dispatch=(dispatch)=>({
  fetch:(id)=>dispatch(ibFetch(id)),
  save:(data)=>dispatch(ibSave(data)),
  danger:(text,sec)=>dispatch(danger(text,sec)),
  platformsFetch: () => dispatch(plaformsFetch()),
  plaformFilter: (filter) => dispatch(plaformFilter(filter))
})
export default withStyles({...styles, ...regularFormsStyle})(connect(state,dispatch)(IbKyc))



// WEBPACK FOOTER //
// ./src/views/Ibs/Wizard/IbKyc.jsx